import { SimpleForm, TextInput } from "react-admin";

import DefaultToolbar from "../components/DefaultToolbar";
import PermissionsInput from "./inputs/PermissionsInput";
import React from "react";

const Form = (props) => (
  <SimpleForm {...props} redirect="list" toolbar={<DefaultToolbar />}>
    <TextInput source="code" />
    <TextInput source="name" />
    <TextInput source="description" fullWidth />
    <PermissionsInput source="permissions" />
  </SimpleForm>
);
export default Form;
